/**
 * Brand hover animation
 */
	const appBrand = document.querySelector('[app-brand] > div')
	let appBrandTransition = true

	if (appBrand) {
		appBrand.addEventListener('mouseover', _ => {
			if (appBrandTransition == true) {
				appBrandTransition == false

				appBrand.classList.add('is--compact')

				setTimeout(() => {
					appBrand.classList.add('is--phrase')
				}, 750)
			}
		})

		appBrand.addEventListener('mouseout', _ => {
			if (appBrandTransition == true) {
				setTimeout(() => {
					appBrand.classList.remove('is--phrase', 'is--compact')
					appBrandTransition == true
				}, 3000)
			}
		})
	}
